import * as React from "react";
import { Box, Grid, Typography } from "@mui/material";
import { ImagesContext } from "../../Context";
import { HtmlTooltip } from "../../patient_reports/health_overview/panels/action_center/ActionRow";

interface Props {
  organization: any;
  claimStatus: string;
}

const OrganizationInfo: React.FC<Props> = ({ organization, claimStatus }) => {
  const images = React.useContext(ImagesContext);

  return (
    <Box className="info-container">
      <Grid container>
        <Grid item xs={3}>
          <Typography className="info-heading-label">
            Organization Name
          </Typography>
          <Typography className="info-heading-text">
            {organization?.name}
          </Typography>
        </Grid>

        <Grid item xs={2}>
          <Typography className="info-heading-label">Address</Typography>
          <Typography className="info-heading-text">
            <>
              {organization?.address}
              <br />
              {organization?.city}, {organization?.state} {organization?.zip}
            </>
          </Typography>
        </Grid>

        <Grid item xs={2}>
          <Typography className="info-heading-label">
            Organization Details
          </Typography>
          <Typography className="info-heading-text">
            <>
              Federal Tax ID: {organization?.federal_tax_id}
              <br />
              Facility NPI: #{organization?.facility_npi}
            </>
          </Typography>
        </Grid>
        {claimStatus !== "submitted" &&
          claimStatus !== "pending_submission" && (
            <Grid item xs={5} display="flex" justifyContent="flex-end">
              <HtmlTooltip
                placement="top"
                arrow
                title={
                  <Box
                    sx={{
                      padding: "8px",
                      background: "#EFE9E8",
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: "13px",
                      }}
                    >
                      Organization Details: If there is any missing or incorrect
                      information, please contact a Starfield Admin to update
                      your details.
                    </Typography>
                  </Box>
                }
                sx={{
                  tooltip: {
                    backgroundColor: "white",
                    color: "black",
                  },
                  arrow: {
                    color: "white",
                  },
                }}
              >
                <div className="item-icon-container">
                  <img
                    src={images.info_orange_icon}
                    alt="edit Icon"
                    className="action-icon-image"
                    style={{ width: 23, maxHeight: 23 }}
                  />
                </div>
              </HtmlTooltip>
            </Grid>
          )}
      </Grid>
    </Box>
  );
};

export default OrganizationInfo;
